/* eslint no-console:0 */

import React from "react"
import { createRoot } from "react-dom/client"

import App from "~/app"
import Router from "~/routers"

createRoot(document.getElementById("app")).render(
  <React.StrictMode>
    <App>
      <Router />
    </App>
  </React.StrictMode>
)
